import { blue } from "@mui/material/colors";
import { forwardRef, useState } from "react";
import DropDownLoading from "../../frames/dropdown_loading";
import { dateUsaToTimestamp, getCurrentDate } from "../../frames/common";
import { newCashNote } from "./note_halper";

const { Dialog, DialogTitle, DialogContent, Grid, Typography, LinearProgress, Button, DialogActions, TextField, Slide, Autocomplete, Box, Stack, Chip, Collapse } = require("@mui/material");

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const refrance = ["Sales", "Purchase", "Contra", "Purchase Return", "Refund", "GST", "Salary", "Rent", "Transport Expanse", "Booking"]

function CashNote({ accounts, open, onClose }) {
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);
    const [inputErrors, setInputErrors] = useState({});
    const [crAccounts, setCrAccounts] = useState([]);
    const [drAccounts, setDrAccounts] = useState([]);
    const [activeFunction, setActiveFunction] = useState("");

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSelfClose = () => {
        if (isLoading) return;
        setInputErrors({});
        setCrAccounts([]);
        setDrAccounts([]);
        setActiveFunction("");
        setAlertMessage(null);
        onClose();
    }

    const handleActiveFunction = (target) => {
        setActiveFunction(target);
        if (target === "receivable") {
            setDrAccounts(accounts.filter((itm) => itm.ac_type === "Sundry Debtors"));
            setCrAccounts(accounts.filter((itm) => itm.ac_type === "Sales Account"));
        } else if (target === "payable") {
            setDrAccounts(accounts.filter((itm) => ["Cash In Hand", "Purchases Account", "Indirect Expenses", "Direct Expenses", "Expenses"].includes(itm.ac_type)));
            setCrAccounts(accounts.filter((itm) => itm.ac_type === "Sundry Creditors"));
        } else if (target === "advance") {
            setDrAccounts(accounts.filter((itm) => itm.ac_type === "Sundry Debtors"));
            setCrAccounts(accounts.filter((itm) => itm.ac_type === "Sales Account"));
        } else if (target === "contra") {
            setDrAccounts(accounts.filter((itm) => ["Bank Account", "Cash In Hand", "Current Assets", "Deposits", "Fixed Assets", "Investment"].includes(itm.ac_type)));
            setCrAccounts(accounts.filter((itm) => ["Bank Account", "Cash In Hand", "Current Assets", "Deposits", "Fixed Assets", "Investment"].includes(itm.ac_type)));
        } else if (target === "sr") {
            setDrAccounts(accounts.filter((itm) => itm.ac_type === "Sundry Debtors"));
            setCrAccounts(accounts.filter((itm) => itm.ac_type === "Sales Account"));
        } else if (target === "pr") {
            setDrAccounts(accounts.filter((itm) => itm.ac_type === "Sundry Creditors"));
            setCrAccounts(accounts.filter((itm) => ["Cash In Hand", "Purchases Account", "Indirect Expenses", "Direct Expenses", "Expenses"].includes(itm.ac_type)));
        }
    }

    const handleSelfSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const date = dateUsaToTimestamp(data.get("date"));
        const debit = Number(data.get("debtor"));
        const credit = Number(data.get("creditor"));
        const amount = Number(data.get("amount"));
        const ref = data.get("ref");
        const description = data.get("description");

        var flag = true;
        if (__error_handler(date !== 0, "date", "The date should be a valid MM-DD-YYYY.")) {
            flag = false;
        }
        if (__error_handler(debit > 0, "debtor", "Incorrect debtor account.")) {
            flag = false;
        }
        if (__error_handler(credit !== debit && credit > 0, "creditor", "Incorrect creditor account.")) {
            flag = false;
        }
        if (__error_handler(amount > 0, "amount", "Amount must be greter than ₹0.")) {
            flag = false;
        }
        if (__error_handler(refrance.includes(ref), "ref", "Please select a transaction refrance.")) {
            flag = false;
        }

        if (flag) {
            setIsLoading(true);
            const _json = { "date": date, "debit": debit, "credit": credit, "amount": amount, "description": description, "ref": ref };
            newCashNote(_json).then((res) => {
                setIsLoading(false);
                handleSelfClose();
            }).catch((err) => {
                setIsLoading(false);
                setAlertMessage(err.message);
            });
        }
    }

    return (
        <Dialog open={open} onClose={handleSelfClose} TransitionComponent={Transition} component="form" onSubmit={handleSelfSubmit}>
            <DialogTitle variant="h5" color="info">New Cash Note</DialogTitle>
            <DialogContent>
                <Collapse in={activeFunction !== ""}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12 }} color={blue[500]}>
                            <Typography variant="caption">Details</Typography>
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6 }}>
                            <TextField variant="outlined" size="small" name="date" fullWidth error={inputErrors.date} type="date" defaultValue={getCurrentDate()} slotProps={{ htmlInput: { max: getCurrentDate(), min: "2024-04-01" } }} helperText={inputErrors.date} placeholder="Date" />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6 }}>
                            <TextField variant="outlined" size="small" name="amount" fullWidth error={inputErrors.amount} type="number" slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000 } }} helperText={inputErrors.amount} placeholder=" ₹" label="Amount" />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6 }}>
                            <Autocomplete
                                disablePortal
                                noOptionsText={<DropDownLoading title="Loading ..." />}
                                options={drAccounts === null ? [] : drAccounts}
                                size="small"
                                getOptionLabel={(option) => option.ac_id.toString()}
                                renderOption={(props, option) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                        <Box key={key} component="li" {...optionProps} >
                                            <Typography variant="body2">{option.name} ({option.ac_id})</Typography>
                                        </Box>
                                    );
                                }}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="debtor" fullWidth error={inputErrors.debtor} type="text" helperText={inputErrors.debtor} placeholder="Debtor" label="Debtor ID" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 6, sm: 6 }}>
                            <Autocomplete
                                disablePortal
                                noOptionsText={<DropDownLoading title="Loading ..." />}
                                options={crAccounts === null ? [] : crAccounts}
                                size="small"
                                getOptionLabel={(option) => option.ac_id.toString()}
                                renderOption={(props, option) => {
                                    const { key, ...optionProps } = props;
                                    return (
                                        <Box key={key} component="li" {...optionProps} >
                                            <Typography variant="body2">{option.name} ({option.ac_id})</Typography>
                                        </Box>
                                    );
                                }}
                                renderInput={(params) => <TextField {...params} variant="outlined" name="creditor" fullWidth error={inputErrors.creditor} type="text" helperText={inputErrors.creditor} placeholder="Creditor" label="Creditor ID" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 3 }}>
                            <Autocomplete
                                disablePortal
                                options={refrance}
                                size="small"
                                renderInput={(params) => <TextField {...params} variant="outlined" name="ref" fullWidth error={inputErrors.ref} type="text" helperText={inputErrors.ref} placeholder="Refrance" label="Refrance" />}
                            />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 9 }}>
                            <TextField variant="outlined" size="small" name="description" fullWidth error={inputErrors.description} type="text" helperText={inputErrors.description} placeholder="Why this transaction was ?" label="Description" />
                        </Grid>
                    </Grid>
                </Collapse>
                <Grid size={{ xs: 12, sm: 12 }} color={blue[500]} sx={{ mt: 2 }}>
                    <Typography variant="caption">What you want to do?</Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Stack direction="row" flexWrap={"wrap"}>
                        <Box sx={{ p: 0.2 }}><Chip label={"Client Receivable"} variant={activeFunction === "receivable" ? "filled" : "outlined"} color="secondary" onClick={() => { handleActiveFunction("receivable"); }} /></Box>
                        <Box sx={{ p: 0.2 }}><Chip label={"Vendor Payment"} variant={activeFunction === "payable" ? "filled" : "outlined"} color="secondary" onClick={() => { handleActiveFunction("payable"); }} /></Box>
                        <Box sx={{ p: 0.2 }}><Chip label={"Advance Received"} variant={activeFunction === "advance" ? "filled" : "outlined"} color="secondary" onClick={() => { handleActiveFunction("advance"); }} /></Box>
                        <Box sx={{ p: 0.2 }}><Chip label={"Contra"} variant={activeFunction === "contra" ? "filled" : "outlined"} color="secondary" onClick={() => { handleActiveFunction("contra"); }} /></Box>
                        <Box sx={{ p: 0.2 }}><Chip label={"Sales Return"} variant={activeFunction === "sr" ? "filled" : "outlined"} color="secondary" onClick={() => { handleActiveFunction("sr"); }} /></Box>
                        <Box sx={{ p: 0.2 }}><Chip label={"Purchase Return"} variant={activeFunction === "pr" ? "filled" : "outlined"} color="secondary" onClick={() => { handleActiveFunction("pr"); }} /></Box>
                    </Stack>
                </Grid>
            </DialogContent>
            {isLoading ? <LinearProgress color="secondary" /> : ""}
            <DialogActions sx={{ pb: 3, px: 3 }}>
                <Typography variant="body2" color="error">{alertMessage}</Typography>
                <Button variant="outlined" disabled={isLoading} onClick={handleSelfClose}>Cancel</Button>
                <Button variant="contained" disabled={isLoading || activeFunction === ""} color="secondary" type="submit">Save</Button>
            </DialogActions>
        </Dialog>
    );
}

export default CashNote;
